import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Divider, LinearProgress, FormHelperText } from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { H3, H6 } from '../../../../../../layouts/TextStyles'
import CustomInput from '../../../../../../components/muiComponents/customInput'
import {
    CourseSubjectPriceState,
    CourseSubjectState,
} from '../../../../../../features/types'
import { capitalize } from '../../../../../../utils/functions'

interface Props {
    values: Values
    errors: any
    courseSubjects: CourseSubjectState[]
    isFetchingSubjects?: boolean
    courseSubjectsValids: boolean[]
    handleChange: (e: React.ChangeEvent<unknown>) => void
    handleBlur: (e: React.FocusEvent<unknown, Element>) => void
}

interface Values {
    courseSubjectsPrice: CourseSubjectPriceState[]
}

const styles = {
    flex: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
    },
    fullWidth: {
        width: '100%',
    },
    error: {
        color: '#d32f2f',
        marginLeft: '12px',
    },
}

const SubjectsTab: React.FC<Props> = ({
    values,
    courseSubjects,
    errors,
    isFetchingSubjects = false,
    courseSubjectsValids,
    handleChange,
    handleBlur,
}) => {
    const { formatMessage, locale } = useIntl()

    const getSubjectTitle = (courseSubjectId: number) => {
        const subject = courseSubjects.find(
            (courseSubject) => courseSubject.id === courseSubjectId,
        )

        if (subject) {
            return subject[`title${capitalize(locale)}`]
        }
    }

    const isValidField = (obj, key, index) => {
        if (
            courseSubjectsValids.length > 0 &&
            !courseSubjectsValids[index] &&
            !obj[key]
        ) {
            return (
                <FormHelperText style={styles.error}>
                    {formatMessage({
                        id: 'isRequired',
                    })}
                </FormHelperText>
            )
        }
    }

    return (
        <Box>
            {isFetchingSubjects && <LinearProgress />}
            {values?.courseSubjectsPrice.map((subject, index) => (
                <Box
                    sx={styles.flex}
                    key={subject.courseSubjectId}
                    mt={2}
                >
                    <H6>
                        {getSubjectTitle(subject.courseSubjectId) +
                            ' ' +
                            formatMessage({
                                id: 'price',
                            })?.toLowerCase()}
                    </H6>

                    <Box>
                        <CustomInput
                            id={`courseSubjectsPrice[${index}].price`}
                            name={`courseSubjectsPrice[${index}].price`}
                            value={values?.courseSubjectsPrice[index]?.price}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(
                                errors.courseSubjectsPrice &&
                                    errors.courseSubjectsPrice[index]?.price,
                            )}
                            helperText={
                                errors.courseSubjectsPrice &&
                                errors.courseSubjectsPrice[index]?.price
                            }
                            placeholder={' '}
                        />

                        {isValidField(
                            { ...values?.courseSubjectsPrice[index] },
                            'price',
                            index,
                        )}
                    </Box>

                    <FormControlLabel
                        control={
                            <Checkbox
                                name={`courseSubjectsPrice[${index}].isActive`}
                                checked={
                                    values?.courseSubjectsPrice[index]?.isActive
                                }
                                onChange={handleChange}
                            />
                        }
                        label="Активный"
                    />
                    <Divider />
                </Box>
            ))}
        </Box>
    )
}

export default SubjectsTab
